// extracted by mini-css-extract-plugin
export default {"dateRange":"UserProfileBalanceHistory_dateRange__BOBrO"};